<template>
    <apex-charts class="shedule" width="350" type="radialBar" :options="options" :series="series"></apex-charts>
</template>
<script>
    // https://apexcharts.com/docs/options/plotoptions/radialbar/
    import color from './colors'
    import ApexCharts from 'vue-apexcharts'

    export default {
        props: {
            value: Number,
            level: Number,
            max: {
                type: Number,
                default: 500
            }
        },
        components: {
            ApexCharts
        },
        computed: {
            colors () {
                return [color[this.level]]
            },
            series () {
                return [this.percent]
            },
            percent () {
                return (this.value * 100) / this.max
            },
            options () {
                return {
                    colors: this.colors,
                    labels: ['Баллов'],
                    plotOptions: {
                        radialBar: {
                            size: 200,
                            hollow: {
                                size: '40%',
                            },
                            dataLabels: {
                                showOn: 'always',
                                name: {
                                    show: true,
                                    fontSize: '20px',
                                    offsetY: -15
                                },
                                value: {
                                    show: true,
                                    fontSize: '20px',
                                    offsetY: 10,
                                    formatter: () => {
                                        return this.value + ' из ' + this.max
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</script>
<style lang="stylus" scoped>
    .shedule {
        /deep/ .apexcharts-canvas {
            margin 0 auto
        }
    }
</style>
